import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "side-nav" }
const _hoisted_2 = { class: "side-nav__items" }
const _hoisted_3 = { class: "side-nav__current-org" }
const _hoisted_4 = {
  key: 0,
  class: "side-nav__item"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_6 = {
  key: 1,
  class: "side-nav__item"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Players ")
const _hoisted_8 = {
  key: 2,
  class: "side-nav__item"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Integrations ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Beta")
const _hoisted_11 = {
  key: 3,
  class: "side-nav__item"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" API Tokens ")
const _hoisted_13 = {
  key: 4,
  class: "side-nav__item"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Members ")
const _hoisted_15 = { class: "side-nav__item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Downloads ")
const _hoisted_17 = {
  key: 5,
  class: "side-nav__item"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Billing ")
const _hoisted_19 = { class: "side-nav__item side-nav__tempest-ad" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "side-nav__tempest-logo",
  src: "/tempest-logo.svg"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_badge = _resolveComponent("badge")!
  const _component_external_anchor = _resolveComponent("external-anchor")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, _toDisplayString(_ctx.currentOrg?.name), 1),
      (_ctx.permissions?.manageSettings)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "side-nav__anchor",
              to: `/dashboard/${_ctx.$route.params.subdomain}/settings`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_fa_icon, {
                  class: "medium-em",
                  icon: ['fas', 'cog']
                }),
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.permissions?.readPlayers)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "side-nav__anchor",
              to: `/dashboard/${_ctx.$route.params.subdomain}/players`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_fa_icon, {
                  class: "medium-em",
                  icon: ['fas', 'database']
                }),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.permissions?.administrator)
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "side-nav__anchor",
              to: `/dashboard/${_ctx.$route.params.subdomain}/integrations`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_fa_icon, {
                  class: "medium-em",
                  icon: ['fas', 'bolt']
                }),
                _hoisted_9,
                _createVNode(_component_badge, { class: "side-nav__badge" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.permissions?.manageApiTokens)
        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "side-nav__anchor",
              to: `/dashboard/${_ctx.$route.params.subdomain}/tokens`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_fa_icon, {
                  class: "medium-em",
                  icon: ['fas', 'key']
                }),
                _hoisted_12
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.permissions?.administrator)
        ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              class: "side-nav__anchor",
              to: `/dashboard/${_ctx.$route.params.subdomain}/members`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_fa_icon, {
                  class: "medium-em",
                  icon: ['fas', 'user-astronaut']
                }),
                _hoisted_14
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "side-nav__anchor",
          to: `/dashboard/${_ctx.$route.params.subdomain}/downloads`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_fa_icon, {
              class: "medium-em",
              icon: ['fas', 'download']
            }),
            _hoisted_16
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.isOwner)
        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
            _createVNode(_component_router_link, {
              class: "side-nav__anchor",
              to: `/dashboard/${_ctx.$route.params.subdomain}/billing`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_fa_icon, {
                  class: "medium-em",
                  icon: ['fas', 'credit-card']
                }),
                _hoisted_18
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_19, [
        _createVNode(_component_external_anchor, {
          class: "side-nav__anchor",
          href: "https://portal.tempest.net/aff.php?aff=107",
          "show-icon": false
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ])
    ])
  ]))
}